export default {
	routes: {
		home: {
			path: '/',
			name: 'home',
		},

		portfolio: {
			path: '/portfolio/',
			name: 'portfolio',
		},

		aboutUs: {
			path: '/about-us/',
			name: 'aboutUs',
			isFooter: true,
		},

		contactUs: {
			path: '/contact-us/',
			name: 'contact',
			isFooter: true,
		},

		faq: {
			path: '/faq/',
			name: 'faq',
			isFooter: true,
		},

		termsConditions: {
			path: '/terms-and-conditions/',
			name: 'termsAndConditions',
			isFooter: true,
		},

		notFound: {
			path: '/not-found/',
			name: 'notFound',
			isFooter: true,
		},
	},
};
